import { render, staticRenderFns } from "./BaseManagementList.vue?vue&type=template&id=0b5f4a1c&scoped=true&"
import script from "./BaseManagementList.vue?vue&type=script&lang=js&"
export * from "./BaseManagementList.vue?vue&type=script&lang=js&"
import style0 from "./BaseManagementList.vue?vue&type=style&index=0&id=0b5f4a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f4a1c",
  null
  
)

export default component.exports